var React = require('react');

function SubmenuItemActiveIco (props) {
    return React.createElement("svg",props,React.createElement("circle",{"id":"Ellipse_8126","data-name":"Ellipse 8126","cx":"3.904","cy":"3.904","r":"3.904","fill":"#522ded"}));
}

SubmenuItemActiveIco.defaultProps = {"width":"7.809","height":"7.809","viewBox":"0 0 7.809 7.809"};

module.exports = SubmenuItemActiveIco;

SubmenuItemActiveIco.default = SubmenuItemActiveIco;
